import { FormControl } from '@angular/forms';

export function dateValidator(control: FormControl): { date: true } | null {
  const DATE_PATTERN = new RegExp('^\\d{2} [a-zA-Z]{3} \\d{4}$');

  return control.value !== '' &&
    DATE_PATTERN.test(control.value) &&
    !isNaN(new Date(control.value).getTime())
    ? null
    : { date: true };
}
